import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'

import { TenantExpanded } from '@engine/models'

import { Table } from '#components/Table'

interface TenantsListProps {
  tenants: TenantExpanded[]
  selectedId?: string
  onSelect: (tenant: TenantExpanded) => void
}

const columnHelper = createColumnHelper<TenantExpanded>()

const TenantsList = ({ tenants, selectedId, onSelect }: TenantsListProps) => {
  const columns = useMemo(
    () => [
      columnHelper.display({
        id: 'username',
        header: 'Username',
        cell: info => {
          const tenant = info.row.original
          return (
            <>
              <div className="font-semibold">{tenant.username}</div>
              <div className="text-xs opacity-60">{tenant._id}</div>
            </>
          )
        },
      }),
      columnHelper.accessor('createdAt', {
        id: 'createdAt',
        header: 'Created At',
      }),
      columnHelper.accessor('isThirdPartyLogistics', {
        header: 'Type',
        cell: info => (
          <span className="badge badge-outline text-xs">
            {info.getValue() ? '3PL' : 'Direct'}
          </span>
        ),
      }),
    ],
    [],
  )

  return (
    <Table
      data={tenants}
      columns={columns}
      getRowId={tenant => tenant._id}
      onRowClick={onSelect}
      selectedId={selectedId}
    />
  )
}

export { TenantsList }
